import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'
import EditorDropDown from '../../molecules/EditorDropDown/EditorDropDown'
import EditorLimitTextField from '../../molecules/EditorLimitTextField/EditorLimitTextField'
import LimitTextAreaField from '../../molecules/LimitTextAreaField/LimitTextAreaField'
import { QuestionType } from '../../../../commons/EditorStatus'
import './EditProblemItem.css'

// ItemType
export const Type = {
  DROPDOWN: 'dropDown',
  TEXTFIELD: 'textField',
  TEXTAREA: 'textArea'
}

const EditProblemItem = ({ idx, itemType, problemTitle, contents, onChangeProblemContent, selectedValue }) => {
  let item = ''
  if (itemType === Type.DROPDOWN) {
    item = (
      <div styleName="section">
        <p styleName="title">{problemTitle}</p>
        <EditorDropDown
          idx={idx}
          handleChange={onChangeProblemContent}
          optionsContents={contents}
          value={itemType}
          selectedValue={selectedValue}
        />
      </div>
    )
  } else if (itemType === Type.TEXTFIELD) {
    item = (
      <div styleName="section">
        <p styleName="title">{problemTitle}</p>
        <EditorLimitTextField
          index={idx}
          text={contents}
          limitLength={30}
          showLimitCount={true}
          showImage={false}
          showRadioButton={false}
          onChangeText={onChangeProblemContent}
        />
      </div>
    )
  } else if (itemType === Type.TEXTAREA) {
    item = (
      <div styleName="section">
        <p styleName="title">{problemTitle}</p>
        <LimitTextAreaField idx={idx} limitLength={30} text={contents} handleChange={onChangeProblemContent} />
      </div>
    )
  } else {
    item = null
  }
  return item
}

EditProblemItem.propTypes = {
  idx: PropTypes.string,
  itemType: PropTypes.string,
  problemTitle: PropTypes.string,
  contents: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onChangeProblemContent: PropTypes.func
}

EditProblemItem.defaultProps = {
  itemType: 'dropdown',
  contents: [
    {
      label: '4択クイズ',
      value: QuestionType.FOURCHOICE
    },
    {
      label: 'マルバツクイズ',
      value: QuestionType.TRUEFALSE
    }
  ]
}

export default compose(pure)(EditProblemItem)
